import styled from 'styled-components';

export const Wrapper = styled.a<{ $height: number }>`
	display: inline-block;
	position: relative;
	z-index: 1000;
	height: ${p => p.$height}px;
`;
